import { createGlobalStyle } from 'styled-components' ;   
 
const GlobalStyle = createGlobalStyle `
    html,body {
        min-height: 100vh;
        min-width: 100vw;
        margin: 0px;
        overflow-x: hidden;
    }

    input:focus-visible {
        outline:none !important;
    }
    input{
        border: none;
    }
` ;

export default GlobalStyle;